import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-smash-switch-send-receive',
  templateUrl: './smash-switch-send-receive.component.html',
  styleUrls: ['./smash-switch-send-receive.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmashSwitchSendReceiveComponent),
      multi: true
    }
  ]
})
export class SmashSwitchSendReceiveComponent implements OnInit {

  @Input('value') _value: any;
  @Input('disabled') disabled: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  onChange: any = () => { };
  onTouch: any = () => { };

  constructor() { }

  ngOnInit(): void { }

  get value(): boolean {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouch(val);
    this.valueChange.emit(val);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouch = fn;
  }

  writeValue(value) {
    this.value = value;
  }

}
